import { PriceBookDetailRowSchema } from "@redotech/redo-inventory-common/price-book/price-book";
import { priceBookIdFormat } from "@redotech/redo-marketplace-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getPriceBook = unaryRpc({
  name: "getPriceBook" as const,
  input: z.object({ priceBookId: priceBookIdFormat.schema }),
  output: z.object({ priceBook: PriceBookDetailRowSchema.nullable() }),
});
